import { Actions } from '../../../navigation';
import { BackHandler, Linking, Platform } from 'react-native';
import { backIcon } from '@mmt/legacy-commons/Helpers/displayHelper';
import BookedBackIcon from '@mmt/legacy-assets/src/home.webp';
import { trackClickEventProp61, trackPageVisits } from '../Analytics';
import {
  getPokusConfig,
  getPokusConfigWaitingPromise,
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import AbConfigKeyMappings, { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import ViewControllerModule from '@mmt/legacy-commons/Native/ViewControllerModule';
import { isPhonePePlatform } from '../../../Utils/RisUtils';
import _isEmpty from 'lodash/isEmpty';
import { RISData, RISDataMap } from '../Interfaces';
import { data } from './constants';
import { getScreenWidth } from '../../Review/AvailabilityStatusChange/AvailabilityChangeUtils';
import {
  setDataToAsyncStorage,
  RAILS_BUS_COMMON_LANDING,
  RAILS_MMT_ID,
} from '../../../Utils/RailsConstant';
import { navigation } from '@mmt/navigation';
import { _label } from '../../../vernacular/AppLanguage';
import { isIos, isMweb, isApp } from '../../../Utils/device';
import BusSharedModuleHolder from '@mmt/bus-shared/src';
import GenericModule from '@mmt/legacy-commons/Native/GenericModule';
import { getConfigStore } from 'apps/rails/src/configStore/Common/RailsConfigStoreUtils';
import { configKeys } from 'apps/rails/src/configStore/Common/constants';
import RAIL_EVENTS from 'apps/rails/src/RailsOmnitureTracker';

const bookTrainIcon = require('@mmt/legacy-assets/src/ic_raillanding_booktrain.webp');
const bookMetroIcon = require('@mmt/legacy-assets/src/metroIcon.webp');
const busIcon = require('@mmt/legacy-assets/src/bus_icon_whitebg.webp');
const pnrStatusIcon = require('@mmt/legacy-assets/src/rails/checkPNRStatus.webp');
const tgsStatusIcon = require('@mmt/legacy-assets/src/TG_RIS.webp');
const seatAvailabilityIcon = require('@mmt/legacy-assets/src/ic_raillanding_seatavailability.webp');
const liveStationIcon = require('@mmt/legacy-assets/src/rails/liveStation.webp');
const trainScheduleIcon = require('@mmt/legacy-assets/src/rails/trainSchedule.webp');
const coachPositionIcon = require('@mmt/legacy-assets/src/rails/coachPosition.webp');
const food_web_icon = require('@mmt/legacy-assets/src/rails/foodInTrain.webp');
const vaccant_chart_icon = require('@mmt/legacy-assets/src/vaccant_chart.webp');
const liveTrainStatus = require('@mmt/legacy-assets/src/rails/liveTrainStatus.webp');
const rail_madad_icon = require('@mmt/legacy-assets/src/rail_madad.webp');

export const getBookingLOBS = (railsBusCommonLanding: boolean = false) => {
  const bookingLOBSMap = {
    train: {
      label: "book_train_tickets",
      icon: bookTrainIcon,
      onClick: () => onBookTrainClicked(railsBusCommonLanding),
    },
    metro: {
      label: "book_metro_tickets",
      icon: bookMetroIcon,
      onClick: onBookMetroClicked,
    },
    bus: {
      label: "book_bus_tickets",
      icon: busIcon,
      onClick: () => onBusClicked(railsBusCommonLanding),
    },
  };
  return bookingLOBSMap;
};

export const getRisAb = async () => {
  if (isApp()) {
    try {
      await getPokusConfigWaitingPromise(1000);
    } catch (error) {
      console.log('RIS ab error');
    }
  }
  const risOptions: string =  getPokusConfig(
    PokusLobs.RAIL,
    AbConfigKeyMappings.rails_RIS_options_NEW,
    'CPS|FIT|LTS|STS|CSA|LSS|CPP|VCH',
  );
  const arr = risOptions.split('|')
  return arr;
};

export const getAdsAb = async () => {
  const adsOption: boolean = getPokusConfig(
    PokusLobs.RAIL,
    AbConfigKeyMappings.railsBusAdsOptions,
    false,
  );
  return adsOption;
};

export const onHardBackPress = () => {
  if (isIos()) {
    ViewControllerModule.thankyouDismiss();
  } else if (isMweb()) {
    //redirect back to phonepev2 landing page
    if (isPhonePePlatform()) {
      window.location.href = 'https://www.makemytrip.com?action=phonePeV2';
      return true;
    }
    window.location.href = 'https://www.makemytrip.com';
  } else {
    BackHandler.exitApp();
    // Actions.pop();
  }
  setDataToAsyncStorage(RAILS_BUS_COMMON_LANDING, null);
  return true;
};

export const getAppropriateFontSizeRIS = () => {
  const width = getScreenWidth();
  if (width < 360) {
    return 12;
  } else {
    return 14;
  }
};

export const getRisOptions = (
  options: string[],
  railsBusCommonLanding: boolean = false,
  isHdfcSmartBuy: boolean = false,
): RISData[] => {
  if (!options) {
    return [];
  }
  const risOptionsData: RISData[] = [];
  const risDataMap: RISDataMap = getRISData(railsBusCommonLanding, isHdfcSmartBuy);
  options.forEach((risOption) => {
    if (risDataMap[risOption] !== undefined) {
      risOptionsData.push(risDataMap[risOption]);
    }
  });
  if (_isEmpty(risOptionsData)) {
    return [];
  }
  return risOptionsData;
};

export const onTGSStatusClicked = (isHdfcSmartBuy = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME,'rails_tgs_icon_rislp_clicked');
  Actions.tgsLandingPage()
};

const getRISData = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  const risDataMap = {
    TGS: {
      icon: tgsStatusIcon,
      text: "trip_guarantee",
      onClick: () => onTGSStatusClicked(isHdfcSmartBuy),
    },
    CPS: {
      icon: pnrStatusIcon,
      text: "check_pnr_status",
      onClick: (isRis : boolean) => onPnrStatusClicked(railsBusCommonLanding, isRis, isHdfcSmartBuy),
    },
    LTS: {
      icon: liveTrainStatus,
      text: 'live_train_status',
      onClick: () => onLiveTrainStatusClicked(railsBusCommonLanding, isHdfcSmartBuy),
    },
    STS: {
      icon: trainScheduleIcon,
      text: "see_train_schedule",
      onClick: () => onSeeTrainScheduleClicked(railsBusCommonLanding, isHdfcSmartBuy),
    },
    CSA: {
      icon: seatAvailabilityIcon,
      text: "check_train_availability",
      onClick: () => onSeeSeatAvailabilityClicked(railsBusCommonLanding, isHdfcSmartBuy),
    },
    LSS: {
      icon: liveStationIcon,
      text: "live_station",
      onClick: () => onLiveStationClicked(railsBusCommonLanding, isHdfcSmartBuy),
    },
    CPP: {
      icon: coachPositionIcon,
      text: "train_coach_position",
      onClick: () => onCoachPositionClicked(railsBusCommonLanding, isHdfcSmartBuy),
    },
    FIT: {
      icon: food_web_icon,
      text: "food_in_trains",
      onClick: () => openFoodInTrainWebView(isHdfcSmartBuy),
    },
    VCH: {
      icon: vaccant_chart_icon,
      text: "vacant_chart",
      onClick: openVacantChartWebView,
    },
    RMD: {
      icon: rail_madad_icon,
      text: 'rail_madad',
      onClick: openRailMadadWebView,
    },
  };
  return risDataMap;
};




export const onPnrStatusClicked = (railsBusCommonLanding: boolean, isRis: boolean, isHdfcSmartBuy: boolean = false) => {
  let trackEvent = 'railris_pnr_status_train&bus_icon_clicked';
  if (isRis) {
    trackEvent = 'railris_pnr_status_pnrstatus_icon_clicked';
  }
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, trackEvent);
  Actions.railsPNRStatusLanding({
    isFromNewLanding: true,
    railsBusCommonLanding,
  });
  // Actions.replace({
  //   key: 'railsPNRStatusLanding', params: {
  //     isFromNewLanding: true,
  //     railsBusCommonLanding,
  //   }
  // });
}

export const onLiveTrainStatusClicked = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'railris_live_train_status_clicked');
  if (Platform.OS === 'web') {
    Actions.railLiveTrainStatusLanding();
  } else {
    GenericModule.openDeepLink(data.LTS_LANDING_DEEPLINK.replace('${railsBusCommonLanding}',railsBusCommonLanding.toString()));
  }
};

const onSeeTrainScheduleClicked = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'railris_train_schedule_clicked');
  Actions.trainScheduleCheck({
    isFromNewLanding: true,
    title: data.STS_TITLE,
    railsBusCommonLanding,
  });
};

const onSeeSeatAvailabilityClicked = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'railris_train_availability_clicked');
  Actions.rails({
    isFromNewLanding: true,
    railsBusCommonLanding,
  });
};

const onLiveStationClicked = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'railris_live_station_clicked');
  Actions.railLiveStationLanding({
    isFromNewLanding: true,
    railsBusCommonLanding,
  });
};

const onCoachPositionClicked = (railsBusCommonLanding: boolean, isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'railris_coach_position_clicked');
  const props = {
    isCoachPosition: true,
    title: data.CPP_TITLE,
    isFromNewLanding: true,
    railsBusCommonLanding,
  };
  isMweb() ? Actions.coachPosition(props) : Actions.trainScheduleCheck(props);
};

const openFoodInTrainWebView = (isHdfcSmartBuy: boolean = false) => {
  trackClickEventProp61(isHdfcSmartBuy ? data.HDFC_LANDING_PAGE : data.PAGE_NAME, 'mob_rail_food_RIScard_clicked');
  Actions.openWebView({
    url: data.FIT_URL,
    headerText: data.FIT_TITLE,
    headerIcon: backIcon,
  });
};
const ExeJS = () =>{
  console.log("ExeJS",document.getElementById('react-select-4-input').disabled);
  document.getElementById('react-select-4-input').disabled = false;
}


const openVacantChartWebView = () => {
  trackClickEventProp61(data.PAGE_NAME, 'railris_vacantcharts_iconclicked');
  Actions.openWebView({
    url: data.SEAT_CHART_URL,
    headerText: data.VCH,
    headerIcon: backIcon,
  });
};

const openRailMadadWebView = async () => {
  trackClickEventProp61(data.PAGE_NAME, RAIL_EVENTS.LANDING.RAILS_RAIL_MADAD_CLICKED);
  const response = await getConfigStore(configKeys.RAILS_MASTER_CONFIG);
  const railMadadUrl = response?.railMadadUrl || data.RAIL_MADAD_URL;
  if(Platform.OS === 'web'){
    window.open(railMadadUrl, '_blank');
  } else{
    Actions.openWebView({
      url: railMadadUrl,
      headerText: data.RMD,
      headerIcon: backIcon,
    });
  }
};

const onBookTrainClicked = (railsBusCommonLanding: boolean) => {
  trackClickEventProp61(data.PAGE_NAME, 'railris_book_train_tickets');
  Actions.rails({
    isFromNewLanding: true,
    railsBusCommonLanding,
  });
};

const onBookMetroClicked = () => {
  Actions.MetroLobEntrance({ lastPageKey: data.PAGE_KEY });
};

const onBusClicked = (railsBusCommonLanding: boolean) => {
  trackClickEventProp61(data.PAGE_NAME, 'railris_book_bus_tickets');
  const busSharedResourceProvider = BusSharedModuleHolder.get();
  if (!busSharedResourceProvider) {
    throw new Error('Bus-Shared module not bootstrapped');
  }
  const busNavigation = busSharedResourceProvider.getBusSharedNavigation();
  busNavigation.openBus({ railsBusCommonLanding });
};
